var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFutureCallback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 102,
    viewBox: "0 0 116 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1084 35.7975C31.1467 28.1256 36.5865 21.1267 44.2585 20.1651L65.2252 17.537C72.8971 16.5754 79.896 22.0152 80.8577 29.6871L83.4857 50.6538C84.4473 58.3257 79.0076 65.3246 71.3356 66.2863L50.3689 68.9143C42.697 69.8759 35.6981 64.4362 34.7364 56.7642L32.1084 35.7975Z",
    fill: "url(#paint0_linear_8040_11247)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1084 35.7975C31.1467 28.1256 36.5865 21.1267 44.2585 20.1651L65.2252 17.537C72.8971 16.5754 79.896 22.0152 80.8577 29.6871L83.4857 50.6538C84.4473 58.3257 79.0076 65.3246 71.3356 66.2863L50.3689 68.9143C42.697 69.8759 35.6981 64.4362 34.7364 56.7642L32.1084 35.7975Z",
    fill: "url(#paint1_linear_8040_11247)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0344 36.1215L66.8479 34.6332C66.7819 34.1069 66.4852 33.6314 66.023 33.3113C65.5608 32.9912 64.9709 32.8528 64.3833 32.9265L48.8721 34.8707C48.2844 34.9444 47.747 35.2241 47.3781 35.6483C47.0092 36.0726 46.839 36.6066 46.905 37.1329L48.6462 51.0242C48.7122 51.5505 49.0089 52.026 49.4711 52.3461C49.9333 52.6662 50.5231 52.8046 51.1108 52.7309L54.9886 52.2449",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8125 31.3594L61.31 35.3283",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9453 32.4688L52.4428 36.4377",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4062 41.1016L52.9459 40.4072",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4019 46.5301L62.5907 45.5478L62.3047 43.2656",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2963 51.1986C66.9677 50.7384 69.6099 47.6999 69.1977 44.4119C68.7856 41.124 65.4753 38.8316 61.8039 39.2918C58.1325 39.7519 55.4903 42.7904 55.9025 46.0784C56.3146 49.3664 59.6249 51.6588 63.2963 51.1986Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_8040_11247",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6848 22.3429C64.2246 18.6716 66.8278 15.3223 70.4992 14.8621C74.1706 14.4019 77.5198 17.0051 77.98 20.6764C78.4402 24.3478 75.837 27.6971 72.1657 28.1573C68.4943 28.6175 65.145 26.0143 64.6848 22.3429Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.6848 22.3429C64.2246 18.6716 66.8278 15.3223 70.4992 14.8621C74.1706 14.4019 77.5198 17.0051 77.98 20.6764C78.4402 24.3478 75.837 27.6971 72.1657 28.1573C68.4943 28.6175 65.145 26.0143 64.6848 22.3429Z",
    fill: "url(#paint2_linear_8040_11247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6848 22.3429M77.98 20.6764M77.98 20.6764M64.6848 22.3429M70.4992 14.8621M77.98 20.6764M72.1657 28.1573M64.6848 22.3429M72.1657 28.1573L71.9169 26.1728C69.3415 26.4956 66.9921 24.6696 66.6693 22.0942L64.6848 22.3429L62.7003 22.5917C63.2979 27.359 67.647 30.7393 72.4144 30.1418L72.1657 28.1573ZM77.98 20.6764L75.9956 20.9252C76.3184 23.5006 74.4923 25.85 71.9169 26.1728L72.1657 28.1573L72.4144 30.1418C77.1818 29.5442 80.5621 25.1951 79.9645 20.4277L77.98 20.6764ZM70.4992 14.8621L70.7479 16.8465C73.3233 16.5237 75.6727 18.3498 75.9956 20.9252L77.98 20.6764L79.9645 20.4277C79.3669 15.6603 75.0178 12.28 70.2504 12.8776L70.4992 14.8621ZM70.4992 14.8621L70.2504 12.8776C65.4831 13.4752 62.1028 17.8243 62.7003 22.5917L64.6848 22.3429L66.6693 22.0942C66.3465 19.5188 68.1725 17.1694 70.7479 16.8465L70.4992 14.8621Z",
    fill: "white",
    mask: "url(#path-9-inside-1_8040_11247)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11247",
    x: -1.63281,
    y: -16.2031,
    width: 118.859,
    height: 118.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11247"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11247",
    x: 18.3672,
    y: 13.7969,
    width: 78.8594,
    height: 78.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11247",
    result: "effect2_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11247",
    x: 51.8516,
    y: 12.0312,
    width: 38.9609,
    height: 38.9609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11247",
    result: "effect2_dropShadow_8040_11247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11247",
    x1: 30.3672,
    y1: 21.9062,
    x2: 85.2269,
    y2: 64.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11247",
    x1: 30.3672,
    y1: 21.9062,
    x2: 85.2269,
    y2: 64.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11247",
    x1: 63.8516,
    y1: 15.6953,
    x2: 78.8133,
    y2: 27.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7986,
    height: 24,
    fill: "white",
    transform: "translate(42.8359 31.5938) rotate(-7.14443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureCallback);
export default __webpack_public_path__ + "static/media/Future Call back.dc0af132d32eedc670d790a9ae44cfe8.svg";
export { ForwardRef as ReactComponent };